import classNames from 'classnames'
import { noop } from 'lodash'
import React, { useCallback } from 'react'

import { Popup as MapGlPopup } from 'react-map-gl'
import { v4 } from 'uuid'

import { PinData } from './types'

interface Props extends PinData {
  shouldShow?: boolean
  onClosePopup?(id: string, forceState?: 'close' | 'open'): void
}

const offset = [-4, -24] as [number, number]

export const Popup: React.FC<Props> = React.memo(
  ({
    latitude = 0,
    longitude = 0,
    onClosePopup = noop,
    title,
    text,
    shouldShow,
    id,
  }) => {
    const onClose = useCallback(
      () => onClosePopup(id, 'close'),
      [onClosePopup, id]
    )

    return (
      <MapGlPopup
        latitude={latitude}
        longitude={longitude}
        anchor="bottom"
        offset={offset}
        onClose={onClose}
        className={classNames({
          hidden: !shouldShow,
        })}
      >
        {title && <h6>{title}</h6>}
        {text && text.map(phrase => <p key={v4()}>{phrase}</p>)}
      </MapGlPopup>
    )
  }
)
